import {
  BooleanField,
  CreateButton,
  Datagrid,
  EmailField,
  ExportButton,
  FunctionField,
  List,
  NullableBooleanInput,
  TextField,
  TextInput,
  TopToolbar,
} from "react-admin";
import { useAdmin } from "../../hooks/admin";
import { CustomPagination } from "../shared/pagination";
import { ModalImageField } from "@/components/elements/ModalImageField";

const SupplierFilter = [
  <NullableBooleanInput key="status" source="status" alwaysOn />,
  <TextInput key="name" source="name" alwaysOn />,
  <TextInput key="email" source="email" alwaysOn />,
  <TextInput key="socialReason" source="socialReason" alwaysOn />,
  <TextInput key="contactName" source="contactName" />,
];

const SupplierActions = () => {
  const { hasPermission } = useAdmin();

  return (
    <TopToolbar>
      {/* <FilterButton /> */}
      {hasPermission("supplier.create") && <CreateButton />}
      {hasPermission("supplier.export") && <ExportButton />}
    </TopToolbar>
  );
};

export const SupplierList = () => {
  const { hasPermission } = useAdmin();

  if (!hasPermission("supplier.list")) return null;

  return (
    <List
      sort={{ field: "createdAt", order: "ASC" }}
      perPage={20}
      filters={SupplierFilter}
      pagination={<CustomPagination />}
      hasCreate={hasPermission("supplier.create")}
      actions={<SupplierActions />}
    >
      <Datagrid
        rowClick={hasPermission("supplier.view") ? "show" : undefined}
        bulkActionButtons={false}
      >
        <FunctionField
          label="Logo"
          render={() => (
            <ModalImageField source="logo" maxHeight={80} maxWidth={80} />
          )}
        />
        <TextField source="companyId" />
        <TextField source="name" />
        <EmailField source="email" />
        <TextField source="contactName" />
        <TextField source="socialReason" />
        <TextField source="phone" />
        <BooleanField source="status" />
      </Datagrid>
    </List>
  );
};
